import type { SpeedFactor } from '@bringg/dashboard-sdk/dist/SpeedFactor/Service/SpeedFactor.service';

import { groupByUtcMidnightSplit } from './utc-midnight-split/utc-midnight-split';
import { SpeedFactorGroup } from './types';

export const isFlatSpeedFactor = (group: SpeedFactorGroup): group is SpeedFactor => {
	return !('groupType' in group);
};

export const groupSpeedFactors = (speedFactors: SpeedFactor[]): SpeedFactorGroup[] => {
	const { groups, ungrouped } = groupByUtcMidnightSplit(speedFactors);

	return [...groups, ...ungrouped];
};
